












import Vue from 'vue'
import request from '@/utils/request'
import moment from 'moment'
import warnListContent from '../warninfo/warn_list_content.vue'

import sha1 from 'sha1'
import { WECHAT_APPID,WECAHT_NAME,IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'

export default Vue.extend({
  components: {
    warnListContent
  },

  mounted() {
    // this.getData()
    this.active = this.$store.state.activeIdx
    this.initWeixin()
  },
  watch: {
    active(val) {
      this.$store.commit('setActiveIdx', val)
    },
  },
  data() {
    return {
      active: undefined
    }
  },
  methods: {

    toInfo(id: string) {
      this.$router.push('/article_details?id=' + id)
    },
    dateStr(dateStr: string) {
      let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      //将时间格式化成 yyyy-MM-dd HH:mm:ss
      let formatDateStr = dateStr.toString().replace(pattern, '$1-$2-$3 $4:$5:$6');
      return formatDateStr;
    },
    async initWeixin() {
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: '预警信息',
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },
  },

  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD')
    },
  },
})
